import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const useAnalytics = () => {
  const location = useLocation();

  // Track page views on route change (SPA tracking)
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      // Small delay to ensure document.title is updated by react-helmet-async
      const timeoutId = setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
          page_title: document.title,
        });
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [location]);

  // Track custom events
  const trackEvent = (
    eventName: string,
    eventParams?: Record<string, any>
  ) => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', eventName, eventParams);
    }
  };

  return { trackEvent };
};
